import React from "react";
import allCards from "../../../assets/avantiCards/allCards.png";
import { StyledGalleryContainer, StyledCard } from "../styles";
const CardsAvantiImageGallery = () => {
    return (
        <StyledGalleryContainer>
            <StyledCard
                src={allCards}
                alt="avanti-Cards"
            />
        </StyledGalleryContainer>
    );
};
export default CardsAvantiImageGallery;